import React, { useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { AuthenticationContext } from '../../components/AuthenticationContext';
import Login from '../Login';
import { Box, Card, CardContent, CircularProgress, Grid } from '@mui/material';
import { useQuery } from '@apollo/client';
import { GQL_GET_CAMERA_DETAIL } from '../../graphql/queries/cameras';

export default function CameraAdmin() {
  const history = useHistory();
  const { authorized, removeToken } = useContext(AuthenticationContext);
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { data } = useQuery(GQL_GET_CAMERA_DETAIL, {
    onError(error) {
      if (error.graphQLErrors.findIndex((err) => err?.extensions?.code == 'UNAUTHENTICATED') != -1) {
        removeToken();
      } else {
        setError(error.message);
        console.error(error);
      }
      setLoading(false);
    },
    onCompleted() {
      setLoading(false);
    },
    variables: {
      cameraId: id,
    },
    skip: !authorized,
  });

  if (!authorized) return <Login />;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid container spacing={3} alignItems="center">
                <Grid item flexGrow={1}>
                  <h4
                    style={{ margin: 0, cursor: 'pointer' }}
                    onClick={() => {
                      history.push(`/`);
                    }}
                  >
                    {data?.camera?.client?.name}
                  </h4>
                  <h1 style={{ margin: '0 0 20px' }}>{data?.camera?.name}</h1>
                </Grid>
              </Grid>
              {error && <h3>{error}</h3>}
              {loading && (
                <Box display="flex" minHeight="300px" justifyContent="center" alignItems="center">
                  <CircularProgress />
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
